var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ThemedSelector',{staticClass:"my-auto mx-2",staticStyle:{"max-width":"420px","font-size":"15px"},attrs:{"items":_vm.voyageLegs,"item-text":_vm.displayLeg,"solo":"","flat":"","hide-details":"","color":"primary","item-color":"primary","return-object":"","menu-props":{
    bottom: true,
    offsetY: true,
    maxHeight: 300,
    closeOnContentClick: true,
    transition: 'slide-y-transition',
    eager: true,
  }},on:{"change":_vm.onLegChanged},model:{value:(_vm.selectedLegModel),callback:function ($$v) {_vm.selectedLegModel=$$v},expression:"selectedLegModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }